// Firestore Timestamp | Date | undefined -> milliseconds (0 when missing,
// so older documents saved without a timestamp sort as the oldest).
export function toMillis(ts) {
  if (!ts) return 0;
  if (typeof ts.toMillis === 'function') return ts.toMillis();
  if (ts instanceof Date) return ts.getTime();
  return 0;
}

export const newestFirst = (a, b) => toMillis(b.created_at) - toMillis(a.created_at);
export const oldestFirst = (a, b) => toMillis(a.created_at) - toMillis(b.created_at);
